import { useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import {
  Box,
  Card,
  Table,
  Switch,
  TableBody,
  TableContainer,
  TablePagination,
  FormControlLabel
} from '@mui/material';
import useTable, { getComparator, emptyRows } from '../../hooks/useTable';
// components
import Scrollbar from '../Scrollbar';
import {
  TableEmptyRows,
  TableHeadCustom,
  TableNoData
  // TableSelectedActions
} from '../../fl-components/table';
// sections
import { UserTableToolbar, UserTableRow } from '../../fl-sections/@dashboard/user/list';

const TABLE_HEAD = [
  { id: 'fullName', label: 'Name', align: 'left' },
  { id: 'mobileNumber', label: 'Mobile number', align: 'left' },
  { id: 'city', label: 'City', align: 'left' },
  { id: 'email', label: 'Email', align: 'center' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function UserTable({
  userList,
  openUserDetails,
  filterOption,
  type = 'student',
  displaySelect = true
}) {
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    //
    selected,
    setSelected,
    onSelectRow,
    // onSelectAllRows,
    //
    onSort,
    onChangeDense,
    onChangePage,
    onChangeRowsPerPage
  } = useTable();

  const [tableData, setTableData] = useState(userList);

  const [filterName, setFilterName] = useState('');

  const [filterClass, setFilterClass] = useState('all');
  const handleFilterName = (filterName) => {
    setFilterName(filterName);
    setPage(0);
  };

  const handleFilterClass = (value) => {
    setFilterClass(value);
  };

  const handleDeleteRow = (id) => {
    if (type === 'teacher') {
      // TODO: remove api call for teacher from class
    }
    const deleteRow = tableData.filter((row) => row?.id ?? row?._id !== id);
    setSelected([]);
    setTableData(deleteRow);
  };

  // const handleDeleteRows = (selected) => {
  //   const deleteRows = tableData.filter((row) => !selected.includes(row?.id ?? row?._id));
  //   setSelected([]);
  //   setTableData(deleteRows);
  // };

  const dataFiltered = applySortFilter({
    tableData,
    comparator: getComparator(order, orderBy),
    filterName,
    filterClass
  });
  const denseHeight = dense ? 52 : 72;

  const isNotFound =
    (!dataFiltered.length && !!filterName) || (!dataFiltered.length && !!filterClass);

  return (
    <Card>
      {/* <Container maxWidth={themeStretch ? false : 'lg'} > */}
      {/* <Tabs
            allowScrollButtonsMobile
            variant="scrollable"
            scrollButtons="auto"
            value={filterStatus}
            onChange={onChangeFilterStatus}
            sx={{ px: 2, bgcolor: 'background.neutral' }}
          >
            {STATUS_OPTIONS.map((tab) => (
              <Tab disableRipple key={tab} label={tab} value={tab} />
            ))}
          </Tabs> */}

      {/* <Divider /> */}

      <UserTableToolbar
        onFilterName={handleFilterName}
        optionsRole={filterOption}
        filterRole={filterClass}
        onFilterRole={handleFilterClass}
        displaySelect={displaySelect}
        // isData={!!dataFiltered?.length}
      />

      <Scrollbar>
        <TableContainer sx={{ minWidth: 800, position: 'relative' }}>
          {/* {selected.length > 0 && (
            <TableSelectedActions
              dense={dense}
              numSelected={selected.length}
              rowCount={tableData.length}
              onSelectAllRows={(checked) =>
                onSelectAllRows(
                  checked,
                  tableData.map((row) => row?.id ?? row?._id)
                )
              }
              actions={
                <Tooltip title="Delete">
                  <IconButton color="primary" onClick={() => handleDeleteRows(selected)}>
                    <Iconify icon="eva:trash-2-outline" />
                  </IconButton>
                </Tooltip>
              }
            />
          )} */}

          <Table size={dense ? 'small' : 'medium'}>
            <TableHeadCustom
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={tableData.length}
              numSelected={selected.length}
              onSort={onSort}
              // onSelectAllRows={(checked) =>
              //   onSelectAllRows(
              //     checked,
              //     tableData.map((row) => row?.id ?? row?._id)
              //   )
              // }
            />

            <TableBody>
              {dataFiltered
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const id = row?.userId ? row?.userId?._id ?? row?.userId?.id : row?.id;
                  return (
                    <UserTableRow
                      key={id}
                      row={row}
                      selected={selected.includes(id)}
                      onSelectRow={() => onSelectRow(id)}
                      onDeleteRow={() => handleDeleteRow(id)}
                      onRowClick={() => {
                        openUserDetails(id);
                      }}
                      showOption={type === 'student'}
                    />
                  );
                })}

              <TableEmptyRows
                height={denseHeight}
                emptyRows={emptyRows(page, rowsPerPage, tableData.length)}
              />

              <TableNoData isNotFound={isNotFound} />
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      <Box sx={{ position: 'relative' }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={dataFiltered.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />

        <FormControlLabel
          control={<Switch checked={dense} onChange={onChangeDense} />}
          label="Dense"
          sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
        />
      </Box>
      {/* </Container> */}
    </Card>
  );
}

// ----------------------------------------------------------------------

function applySortFilter({ tableData, comparator, filterName, filterClass }) {
  const stabilizedThis = tableData.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0].userId, b[0].userId);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  tableData = stabilizedThis.map((el) => el[0]);

  if (filterName) {
    tableData = tableData.filter((item) =>
      item?.userId
        ? item.userId.fullName.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
        : item.fullName.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
    );
  }

  if (filterClass !== 'all') {
    tableData = tableData.filter((item) => item.classId.id === filterClass);
  }

  return tableData;
}

UserTable.propTypes = {
  userList: PropTypes.arrayOf(PropTypes.object),
  openUserDetails: PropTypes.func,
  filterOption: PropTypes.arrayOf({}),
  type: PropTypes.string,
  displaySelect: PropTypes.bool
};
